// extracted by mini-css-extract-plugin
export var removeButton = "remove-button_EVIAQCJjK3UQ7aMPeuKA";
export var removeButtonDisabled = "remove-button_disabled_vQwfL66_6mPP84vxHn2k";